
import { setCategories } from "../../store/slices/CategorySlice";
import { setPlaces } from "../../store/slices/PlacesSlice";
import { request } from "../../Utils/request";
import { db } from "../../config/firebase";
import { doc, setDoc, updateDoc, getDoc, serverTimestamp, deleteDoc } from "firebase/firestore";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";



export const fetchCategories = async (dispatch:any, type: string) => {
    try {
      const response = await request<{ data: Array<{ name: string, featured: boolean, priority: number }> }>(`/categories?type=${type}`, {
        method: 'GET'
      });
      const categories = response.data
      dispatch(setCategories(categories));
      // setCategories(categories);
    } catch (error) {
      console.error('Error fetching categories:', error);
      // setCategories([]);
    }
  };

  export const fetchPlaces = async (dispatch:any) => {
    try {
      const response = await request<{ data: Array<{ name: string, featured: boolean, priority: number }> }>('/places', {
        method: 'GET'
      });
      const places = response.data
      dispatch(setPlaces(places));
    } catch (error) {
      console.error('Error fetching places:', error);
    }
  }



  /**
 * Check if a user exists in Firestore (React.js)
 * @param userId - The user ID to check
 * @returns Promise<boolean> - True if user exists, false otherwise
 */
const checkUserExistsInFirestore = async (userId: string): Promise<boolean> => {
  try {
    const userRef = doc(db, "Users", userId); // "Users" collection
    const userDoc = await getDoc(userRef);

    return userDoc.exists();
  } catch (error) {
    console.error("Error checking user existence in Firestore:", error);
    return false;
  }
};


  /**
   * Handle user entry in Firestore - creates new user or updates existing user
   * @param userId - The user ID
   * @param userData - User data to store/update
   * @returns Promise<boolean> - True if successful, false otherwise
   */
  export const handleUserEntryInFirestore = async (
    userId: string,
    userData: { username?: string; email?: string; firstName?: string; lastName?: string;},
    fcmToken?: string
  ): Promise<boolean> => {
    try {
      const userRef = doc(db, "Users", userId);
  
      // Check if user exists in Firestore
      const userExists = await checkUserExistsInFirestore(userId);
  
      if (userExists) {
        await updateDoc(userRef, {
          ...userData,
          fcmToken: fcmToken || '',
          updatedAt: serverTimestamp(),
        });
      } else {
        await setDoc(userRef, {
          ...userData,
          fcmToken: fcmToken || '',
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        });
      }
  
      return true;
    } catch (error: any) {
      console.error("Error handling user entry in Firestore:", error);
  
      // Handle permission denied error specifically
      if (error.code === "permission-denied") {
        return false;
      }
  
      return false;
    }
  };
  

  
  /**
   * Get existing chat between two users or create a new one
   * @param currentUserId - ID of the current user
   * @param otherUserId - ID of the other user
   * @returns Promise<string> - The chatId
   */
  export const getOrCreateChat = async (
    currentUserId: string,
    otherUserId: string
  ): Promise<string> => {
    console.log('^^^^^^^^^^^0', { currentUserId, otherUserId });
    
    // Validate input parameters
    if (!currentUserId || !otherUserId) {
      throw new Error(`Invalid user IDs: currentUserId=${currentUserId}, otherUserId=${otherUserId}`);
    }
    
    // Ensure consistent ordering of participants for consistent querying
    const participants = [currentUserId, otherUserId].sort();
    const participantKey = participants.join('|');
    
    try {
      // First, try to find existing chat using a more comprehensive approach
      console.log('^^^^^^^^^^^searching for existing chat with participants:', participants);
      
      // Try the most efficient query first: using participantKey if it exists
      try {
        const participantKeyQuery = query(
          collection(db, "Chats"),
          where("participantKey", "==", participantKey)
        );
        
        const participantKeySnapshot = await getDocs(participantKeyQuery);
        
        if (!participantKeySnapshot.empty) {
          const existingChat = participantKeySnapshot.docs[0];
          console.log('^^^^^^^^^^^found existing chat using participantKey:', existingChat.id);
          return existingChat.id;
        }
      } catch (keyQueryError) {
        console.log('^^^^^^^^^^^participantKey query not available, falling back to participants query');
      }
      
      // Query 1: Find chats where both users are participants
      const bothUsersQuery = query(
        collection(db, "Chats"),
        where("participants", "array-contains", participants[0])
      );
      
      const bothUsersSnapshot = await getDocs(bothUsersQuery);
      
      let existingChatId: string | null = null;
      
      // Check each chat to see if it has exactly these two participants
      bothUsersSnapshot.forEach((docSnap) => {
        const chatData = docSnap.data();
        if (
          chatData.participants &&
          Array.isArray(chatData.participants) &&
          chatData.participants.length === 2 &&
          chatData.participants.includes(participants[0]) &&
          chatData.participants.includes(participants[1])
        ) {
          existingChatId = docSnap.id;
          console.log('^^^^^^^^^^^found existing chat:', existingChatId, 'with participants:', chatData.participants);
        }
      });
      
      if (existingChatId) {
        return existingChatId;
      }
      
      // Query 2: Also check from the other participant's perspective
      const otherUserQuery = query(
        collection(db, "Chats"),
        where("participants", "array-contains", participants[1])
      );
      
      const otherUserSnapshot = await getDocs(otherUserQuery);
      
      otherUserSnapshot.forEach((docSnap) => {
        const chatData = docSnap.data();
        if (
          chatData.participants &&
          Array.isArray(chatData.participants) &&
          chatData.participants.length === 2 &&
          chatData.participants.includes(participants[0]) &&
          chatData.participants.includes(participants[1])
        ) {
          existingChatId = docSnap.id;
          console.log('^^^^^^^^^^^found existing chat from other user query:', existingChatId, 'with participants:', chatData.participants);
        }
      });
      
      if (existingChatId) {
        return existingChatId;
      }
      
      // If no existing chat found, create a new one
      console.log('^^^^^^^^^^^no existing chat found, creating new one');
      
      // Use a transaction to ensure atomicity and prevent race conditions
      const newChatRef = doc(collection(db, "Chats"));
      const chatId = newChatRef.id;
      
      // Double-check one more time before creating (race condition protection)
      const finalCheckQuery = query(
        collection(db, "Chats"),
        where("participants", "array-contains", participants[0])
      );
      
      const finalCheckSnapshot = await getDocs(finalCheckQuery);
      
      for (const docSnap of finalCheckSnapshot.docs) {
        const chatData = docSnap.data();
        if (
          chatData.participants &&
          Array.isArray(chatData.participants) &&
          chatData.participants.length === 2 &&
          chatData.participants.includes(participants[0]) &&
          chatData.participants.includes(participants[1])
        ) {
          console.log('^^^^^^^^^^^found existing chat on final check:', docSnap.id);
          return docSnap.id;
        }
      }
      
      // Now create the new chat
      // Optional: Initialize lastRead for read receipts (mobile app will initialize on first open if not present)
      const lastRead: Record<string, any> = {
        [participants[0]]: null,
        [participants[1]]: null,
      };
      await setDoc(newChatRef, {
        participants: participants,
        createdAt: serverTimestamp(),
        lastMessageAt: serverTimestamp(),
        participantKey: participantKey, // Add this for easier querying
        lastRead, // Optional: Initialize read receipts
      });
      
      console.log('^^^^^^^^^^^newChatCreated', chatId, 'with participants:', participants);
      return chatId;
      
    } catch (error) {
      console.error("Error in getOrCreateChat:", error);
      
      // Last resort: try to find existing chat one more time
      try {
        console.log('^^^^^^^^^^^last resort: searching for existing chat...');
        const lastResortQuery = query(
          collection(db, "Chats"),
          where("participants", "array-contains", participants[0])
        );
        
        const lastResortSnapshot = await getDocs(lastResortQuery);
        
        for (const docSnap of lastResortSnapshot.docs) {
          const chatData = docSnap.data();
          if (
            chatData.participants &&
            Array.isArray(chatData.participants) &&
            chatData.participants.length === 2 &&
            chatData.participants.includes(participants[0]) &&
            chatData.participants.includes(participants[1])
          ) {
            console.log('^^^^^^^^^^^found existing chat on last resort:', docSnap.id);
            return docSnap.id;
          }
        }
      } catch (retryError) {
        console.error("Last resort query failed:", retryError);
      }
      
      // If all else fails, create a new chat
      console.log('^^^^^^^^^^^all checks failed, creating new chat as last resort');
      const newChatRef = doc(collection(db, "Chats"));
      const chatId = newChatRef.id;
      
      // Optional: Initialize lastRead for read receipts (mobile app will initialize on first open if not present)
      const lastRead: Record<string, any> = {
        [participants[0]]: null,
        [participants[1]]: null,
      };
      await setDoc(newChatRef, {
        participants: participants,
        createdAt: serverTimestamp(),
        lastMessageAt: serverTimestamp(),
        participantKey: participantKey,
        lastRead, // Optional: Initialize read receipts
      });
      
      return chatId;
    }
  };
  

/**
 * Helper function to find duplicate chats between the same users
 * This can be used to identify and clean up duplicate chats
 */
export const findDuplicateChats = async (): Promise<Array<{chatId: string, participants: string[], createdAt: any}>> => {
  try {
    const allChatsQuery = query(collection(db, "Chats"));
    const querySnapshot = await getDocs(allChatsQuery);
    
    const chatMap = new Map<string, Array<{chatId: string, participants: string[], createdAt: any}>>();
    const duplicates: Array<{chatId: string, participants: string[], createdAt: any}> = [];
    
    querySnapshot.forEach((docSnap) => {
      const chatData = docSnap.data();
      if (chatData.participants && Array.isArray(chatData.participants)) {
        // Sort participants to create a consistent key
        const sortedParticipants = [...chatData.participants].sort();
        const key = sortedParticipants.join('|');
        
        if (!chatMap.has(key)) {
          chatMap.set(key, []);
        }
        
        const chatInfo = {
          chatId: docSnap.id,
          participants: chatData.participants,
          createdAt: chatData.createdAt
        };
        
        chatMap.get(key)!.push(chatInfo);
        
        // If we have more than one chat with the same participants, mark as duplicate
        if (chatMap.get(key)!.length > 1) {
          duplicates.push(chatInfo);
        }
      }
    });
    
    console.log('Found duplicate chats:', duplicates);
    return duplicates;
  } catch (error) {
    console.error('Error finding duplicate chats:', error);
    return [];
  }
};

/**
 * Migrate existing chats to add participantKey field for better performance
 * This should be run once to update existing chats
 */
export const migrateChatsToParticipantKey = async (): Promise<{updated: number, errors: number}> => {
  try {
    const allChatsQuery = query(collection(db, "Chats"));
    const querySnapshot = await getDocs(allChatsQuery);
    
    let updated = 0;
    let errors = 0;
    
    for (const docSnap of querySnapshot.docs) {
      try {
        const chatData = docSnap.data();
        if (chatData.participants && Array.isArray(chatData.participants) && !chatData.participantKey) {
          const sortedParticipants = [...chatData.participants].sort();
          const participantKey = sortedParticipants.join('|');
          
          await updateDoc(docSnap.ref, {
            participantKey: participantKey
          });
          
          updated++;
          console.log(`Updated chat ${docSnap.id} with participantKey: ${participantKey}`);
        }
      } catch (updateError) {
        console.error(`Error updating chat ${docSnap.id}:`, updateError);
        errors++;
      }
    }
    
    console.log(`Migration completed: ${updated} chats updated, ${errors} errors`);
    return { updated, errors };
  } catch (error) {
    console.error('Error during migration:', error);
    return { updated: 0, errors: 1 };
  }
};
  

/**
 * Clean up duplicate chats by keeping only the oldest one for each participant pair
 * WARNING: This will delete duplicate chats, so use with caution
 */
export const cleanupDuplicateChats = async (): Promise<{kept: number, deleted: number, errors: number}> => {
  try {
    const allChatsQuery = query(collection(db, "Chats"));
    const querySnapshot = await getDocs(allChatsQuery);
    
    const chatMap = new Map<string, Array<{chatId: string, participants: string[], createdAt: any}>>();
    
    // Group chats by participant key
    querySnapshot.forEach((docSnap) => {
      const chatData = docSnap.data();
      if (chatData.participants && Array.isArray(chatData.participants)) {
        const sortedParticipants = [...chatData.participants].sort();
        const key = sortedParticipants.join('|');
        
        if (!chatMap.has(key)) {
          chatMap.set(key, []);
        }
        
        const chatInfo = {
          chatId: docSnap.id,
          participants: chatData.participants,
          createdAt: chatData.createdAt
        };
        
        chatMap.get(key)!.push(chatInfo);
      }
    });
    
    let kept = 0;
    let deleted = 0;
    let errors = 0;
    
    // Process each group of chats
    for (const [participantKey, chats] of Array.from(chatMap.entries())) {
      if (chats.length > 1) {
        console.log(`Found ${chats.length} chats for participants: ${participantKey}`);
        
        // Sort by creation time (oldest first)
        chats.sort((a: {chatId: string, participants: string[], createdAt: any}, b: {chatId: string, participants: string[], createdAt: any}) => {
          if (!a.createdAt || !b.createdAt) return 0;
          return a.createdAt.toMillis() - b.createdAt.toMillis();
        });
        
        // Keep the oldest chat, delete the rest
        const chatToKeep = chats[0];
        const chatsToDelete = chats.slice(1);
        
        console.log(`Keeping chat ${chatToKeep.chatId} (oldest), deleting ${chatsToDelete.length} duplicates`);
        
        // Delete duplicate chats
        for (const chatToDelete of chatsToDelete) {
          try {
            await deleteDoc(doc(db, "Chats", chatToDelete.chatId));
            deleted++;
            console.log(`Deleted duplicate chat: ${chatToDelete.chatId}`);
          } catch (deleteError) {
            console.error(`Error deleting chat ${chatToDelete.chatId}:`, deleteError);
            errors++;
          }
        }
        
        kept++;
      } else {
        kept++;
      }
    }
    
    console.log(`Cleanup completed: ${kept} chats kept, ${deleted} duplicates deleted, ${errors} errors`);
    return { kept, deleted, errors };
  } catch (error) {
    console.error('Error during cleanup:', error);
    return { kept: 0, deleted: 0, errors: 1 };
  }
};
  

/**
 * Test function to verify getOrCreateChat works correctly
 * Call this to test if the duplicate issue is resolved
 */
export const testGetOrCreateChat = async (userId1: string, userId2: string): Promise<void> => {
  try {
    console.log('🧪 Testing getOrCreateChat with users:', userId1, userId2);
    
    // First call
    const chatId1 = await getOrCreateChat(userId1, userId2);
    console.log('✅ First call returned chat ID:', chatId1);
    
    // Second call with same users (should return same ID)
    const chatId2 = await getOrCreateChat(userId1, userId2);
    console.log('✅ Second call returned chat ID:', chatId2);
    
    // Third call with reversed user order (should return same ID)
    const chatId3 = await getOrCreateChat(userId2, userId1);
    console.log('✅ Third call (reversed order) returned chat ID:', chatId3);
    
    // Check if all IDs are the same
    if (chatId1 === chatId2 && chatId2 === chatId3) {
      console.log('🎉 SUCCESS: All calls returned the same chat ID - no duplicates created!');
    } else {
      console.log('❌ FAILURE: Different chat IDs returned - duplicates still being created');
      console.log('Chat ID 1:', chatId1);
      console.log('Chat ID 2:', chatId2);
      console.log('Chat ID 3:', chatId3);
    }
    
    // Verify the chat exists and has correct participants
    const chatDoc = await getDoc(doc(db, "Chats", chatId1));
    if (chatDoc.exists()) {
      const chatData = chatDoc.data();
      console.log('📋 Chat data:', {
        participants: chatData.participants,
        participantKey: chatData.participantKey,
        createdAt: chatData.createdAt
      });
    }
    
  } catch (error) {
    console.error('❌ Test failed with error:', error);
  }
};
  


